jQuery(($) => {
  const root = document.documentElement;
  const $bar = $('.o-notification-bar');

  if (!$bar.length) {
    return;
  }

  const storageKey = 'popState_' + $bar.attr('data-id');

  const setOffset = (px) => {
    root.style.setProperty('--notification-bar-offset', `${px}px`);
  };

  const measure = () => {
    const on = root.classList.contains('has-notification-bar');
    setOffset(on ? $bar[0].offsetHeight : 0);
  };

  const show = () => {
    root.classList.add('has-notification-bar');
    $('.o-header').addClass('o-header--notification-bar');
    $('.m-page-nav__item-modal').addClass('m-page-nav__item-modal--notification-bar');
    measure();
  };

  const hide = () => {
    root.classList.remove('has-notification-bar');
    $('.o-header').removeClass('o-header--notification-bar');
    $('.m-page-nav__item-modal').removeClass('m-page-nav__item-modal--notification-bar');
    setOffset(0);
  };

  if (localStorage.getItem(storageKey) !== 'shown') {
    show();
  } else {
    hide();
  }

  $bar.find('.o-notification-bar__close-button').on('click', function () {
    localStorage.setItem(storageKey, 'shown');
    $(this).remove();
    hide();
  });

  $(window).on('resize', measure);
});
